import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeach = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1679,
	height: 411,
	fill: "none",
	viewBox: "0 0 1679 411",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFDFA2",
			d: "M0 17h1679v393.7H0V17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint0_linear_15894_38407)",
			d: "M0 0h1679v98.4H0V0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F5D493",
			d: "M 7 141 h 1706 v 20 s -31.7 2.4 -52 3 c -23.8 0.7 -63.4 -1.8 -104 0 c -35.2 1.6 -90 7.5 -90 7.5 c -85.5 0 -197.5 -10.5 -197.5 -10.5 s -25.5 10.6 -70 10.5 c -42.1 0 -109.7 -10.2 -151.8 -10.5 c -53.2 -0.4 -73.5 11.3 -126.7 10.5 c -33.4 -0.5 -61.6 -10.7 -95 -10.5 c -51.1 0.4 -79.5 13.8 -130.5 10.5 c -28.2 -1.8 -43.3 -9.5 -71.5 -10.5 c -36.7 -1.2 -56.8 10.4 -93.5 10.5 c -38.1 0.2 -58.9 -11.2 -97 -10.5 c -32.5 0.6 -50 10.2 -82.5 10.5 c -35.2 0.3 -54.3 -11.7 -89.5 -10.5 c -27 1 -47.7 10.5 -68.5 10.5 c -20.8 0 -48.2 -13 -79.4 -10.5 c -19.5 1.5 -29.5 10 -49.1 10.5 C 40 172 7 161 7 161 v -6 Z",
			className: "wave with-delay"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 131h1706v22s-31.7 2.4-52 3c-23.8.7-63.4-1.8-104 0-35.2 1.6-90 7.5-90 7.5-85.5 0-197.5-10.5-197.5-10.5s-25.5 10.6-70 10.5c-42.1 0-109.7-10.2-151.8-10.5-53.2-.4-73.5 11.3-126.7 10.5-33.4-.5-61.6-10.7-95-10.5-51.1.4-79.5 13.8-130.5 10.5-28.2-1.8-43.3-9.5-71.5-10.5-36.7-1.2-56.8 10.4-93.5 10.5-38.1.2-58.9-11.2-97-10.5-32.5.6-50 10.2-82.5 10.5-35.2.3-54.3-11.7-89.5-10.5-27 1-47.7 10.5-68.5 10.5-20.8 0-48.2-13-79.4-10.5-19.5 1.5-29.5 10-49.1 10.5C34.7 164.2 0 153 0 153v-22Z",
			className: "wave"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint1_linear_15894_38407)",
			d: "M0 98h1702v33H0z",
			className: "wave-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9BD6FE",
			d: "m88.4 65.6.7-.1 227.2 5.7-58.3 4.1L77.7 74c-3.6 0-4.1-5.1-.7-6l11.4-2.4Zm371.8-26.9h.7l227.2 5.6-58.3 4.2-180.3-1.3c-3.6 0-4.1-5.2-.7-6l11.4-2.5Zm376 12h.7l227.2 5.6-58.3 4.2-180.3-1.3c-3.6 0-4.1-5.2-.7-6l11.4-2.5Zm742.8-27a3 3 0 0 0-.8 0L1351 29.2l58.3 4.2 180.3-1.3c3.6 0 4.2-5.2.7-6l-11.4-2.5Z",
			className: "wave-3"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_15894_38407",
			x1: 783.5,
			x2: 783.5,
			y1: -51.6,
			y2: -136,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#74C6FD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2BA6F8"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_15894_38407",
			x1: 684.5,
			x2: 684.5,
			y1: 114.5,
			y2: 131,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#74C6FD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fff"
			})]
		})] })
	]
});
export default SvgBeach;
